import type { WizardTimeHelper } from "../../PermitContextProvider/types";

export const hasNeverExpiresIntervals = (time: WizardTimeHelper | undefined): boolean =>
	time?.neverExpires === true || (time?.intervals?.some((i) => !i.endDateTimeISO) ?? false);
